<div class="aktualnosci-padding um-desktop:aktualnosci-padding-desktop belka-aktualnosci text-white w-full h-full p-4">
  <div class="aktualnosci">
    <div class="tytul-komponentu um-desktop:tytul-komponentu-desktop text-center um-desktop:text-right mb-4">
      <h2 class="um-desktop:um-tytul um-naglowek-a">{{'codes.aktualnosci.aktualnosci' | translate}}</h2>
    </div>
    <div *ngIf="listaAktualnosci.length>0" class="tresc py-8">
      <mm-przewijany-komponent #przewijanyKomponent [stylBialy]="true">
      <div>
        <div class="tresc-data flex um-aktualnosc">
          <mat-icon svgIcon="kalendarz" class="mr-4"></mat-icon>
          <h2 class="capitalize">{{ listaAktualnosci[aktualnyIndex]!.dataUtworzenia | formatujDate:jezyk}}</h2>
        </div>
        <div class="tresc-tytul um-desktop:pb-16 pb-10 pt-6 um-naglowek-a break-words">
          {{jezyk === 'pl' ? listaAktualnosci[aktualnyIndex]!.tytul : listaAktualnosci[aktualnyIndex]!.tytulEn}}
        </div>

        <div class="tresc-zawartosc um-aktualnosc break-words"
             [innerHTML]="jezyk === 'pl' ? listaAktualnosci[aktualnyIndex]!.tresc : listaAktualnosci[aktualnyIndex]!.trescEn ">
        </div>
      </div>
      </mm-przewijany-komponent>
    </div>
  </div>
  <div class="nawigacja flex justify-center">
    <mm-przycisk-okragly ikona="lewa-strzalka" (click)="poprzednia()" [typ]="'BLACK'"
                          label="{{'codes.aktualnosci.etykieta-poprzedni' | translate}}">
    </mm-przycisk-okragly>
    <mm-przycisk-okragly style="margin: 0 16px" ikona="archiwum"  (click)="przekierujDoArchiwum()" [typ]="'BLACK'"
                          label="{{'codes.aktualnosci.etykieta-archiwum' | translate}}">
    </mm-przycisk-okragly>
    <mm-przycisk-okragly ikona="prawa-strzalka" (click)="nastepna()" [typ]="'BLACK'"
                          label="{{'codes.aktualnosci.etykieta-nastepny' | translate}}">
    </mm-przycisk-okragly>
  </div>
</div>
